import { render, staticRenderFns } from "./ForavilaGuarantee.vue?vue&type=template&id=54e961a4&"
import script from "./ForavilaGuarantee.vue?vue&type=script&lang=js&"
export * from "./ForavilaGuarantee.vue?vue&type=script&lang=js&"
import style0 from "./ForavilaGuarantee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports